// frontend/src/pages/Home.js
import React from 'react';

const Home = () => {
    return (
        <div className="container">
            <section
                style={{
                    textAlign: 'center',
                    color: '#FFFFFF',
                    padding: '180px 20px',
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/hero.jpg'})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    borderRadius: '20px',
                    marginBottom: '40px'
                }}
            >
                {/* Dark Overlay for Improved Contrast */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', // Darken overlay for contrast
                    borderRadius: '20px'
                }}></div>

                <div style={{ position: 'relative', zIndex: 1 }}>
                    <h1 style={headingStyle}>Redefining Education for a Mindful Generation</h1>
                    <p style={paragraphStyle}>
                        At Unfamiliar Learning, we empower children to cultivate mindfulness, align with their purpose, and develop emotional well-being from an early age.
                    </p>
                    <a href="/about">
                        <button>Learn More</button>
                    </a>
                </div>
            </section>
        </div>
    );
};

const headingStyle = {
    fontSize: '48px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    marginBottom: '20px',
    color: '#FFD700',    // Gold to match branding
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)' // Text shadow for visibility
};

const paragraphStyle = {
    fontSize: '22px',
    maxWidth: '800px',
    margin: '0 auto 30px',
    lineHeight: '1.8',
    color: '#FFFFFF',   // White with text-shadow for better readability
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.7)' 
};

export default Home;